<template>
  <div class="container-fluid">
    <div class="row">
        <div class="col-12" v-if="performance">
            <div class="card">
                <div class="card-header pb-0">
                  <button 
                    type="button"
                    @click="download"
                    :class="'btn btn-xs btn-outline-primary text-xs font-weight-normal m-0 ' + (loading ? 'disabled' : '')">
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" v-if="loading"></span>
                    <i class="fa fa-download" v-if="!loading"></i> Download
                  </button>
                  <hr/>
                </div>
                <div class="card-body min-vh-50 pt-0">
                    <h5>{{ performance.name }}</h5>
                    <div class="row mt-3">
                        <div class="col-sm-6">
                            <table class="w-100 text-sm">
                                <tr>
                                    <td class="text-secondary w-30 align-top">Vendor</td>
                                    <td class="text-dark">{{ performance.partner_name }}</td>
                                </tr>
                                <tr>
                                    <td class="text-secondary align-top">Vendor Code</td>
                                    <td class="text-dark">{{ performance.partner_code }}</td>
                                </tr>
                                <tr>
                                    <td class="text-secondary align-top">Period</td>
                                    <td class="text-dark">{{ performance.month }} {{ performance.year }}</td>
                                </tr>
                            </table>
                        </div>
                    </div>
                    <div class="table-responsive p-0 mt-3">
                        <table class="table align-items-center mb-0">
                            <thead class="bg-light">
                                <tr>
                                    <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-center">#</th>
                                    <th class="text-uppercase text-xxs font-weight-bolder opacity-7 ps-2">Criteria</th>
                                    <th class="text-uppercase text-xxs font-weight-bolder opacity-7 ps-2">Average</th>
                                    <th class="text-uppercase text-xxs font-weight-bolder opacity-7 ps-2">Score Rate</th>
                                    <th class="text-uppercase text-xxs font-weight-bolder opacity-7 ps-2">Description</th>
                                    <th class="text-uppercase text-xxs font-weight-bolder opacity-7 ps-2">Remark</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="line,i in performance.evaluation_line_ids" :key="line.id">
                                    <td class="text-sm mb-0 text-center w-5">{{ i+1 }}</td>
                                    <td>
                                        <p class="text-sm mb-0">{{ line.criteria }}</p>
                                    </td>
                                    <td>
                                        <p class="text-sm mb-0">{{ line.average }}</p>
                                    </td>
                                    <td>
                                        <p class="text-sm mb-0">{{ line.score_rate }}</p>
                                    </td>
                                    <td>
                                        <p class="text-sm mb-0">{{ line.description }}</p>
                                    </td>
                                    <td>
                                        <p class="text-sm mb-0">{{ line.remark }}</p>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="row justify-content-end mt-3">
                      <div class="col-md-3">
                        <table class="w-100 text-sm">
                            <tr>
                                <td class="text-secondary w-30 align-top">Average</td>
                                <td class="text-dark text-end">{{ performance.summary_average }}</td>
                            </tr>
                            <tr>
                                <td class="text-secondary align-top">Score Rate</td>
                                <td class="text-dark text-end">{{ performance.summary_score_rate }}</td>
                            </tr>
                            <tr>
                                <td class="text-secondary align-top">Description</td>
                                <td class="text-dark text-end">{{ performance.summary_description }}</td>
                            </tr>
                        </table>
                      </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
// import ArgonBadge from "@/components/ArgonBadge.vue";
// import LoadingState from "./components/LoadingState.vue";
const endpoint = require("../router/endpoint");

export default {
  name: "vendor-performance-detail",
  components: {
    // ArgonBadge
    // LoadingState
  },
  data() {
    return {
      performance: null,
      loading: false
    };
  },
  methods: {
    getDetail() {
      this.axios
        .post(
          endpoint.EVALUATION_DETAIL,
          {
            id: this.$route.params.id,
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`
            }
          }
        )
        .then((response) => {
          if (response.data.response_code === "0000") {
            this.performance = response.data.data;
          } else {
            if (response.data.response_code !== "4000"){
              this.$notify({
                type: 'warn',
                title: 'Warning',
                text: response.data.message,
              });
            }
          }
        })
        .catch((e) => {
          this.$notify({
              type: 'error',
              title: 'Something went wrong!',
              text: e.response.data.message,
            });
        });
    },
    download () {
      this.loading = true
      this.axios
        .post(
          endpoint.DOWNLOAD,
          {
            res_id: this.$route.params.id,
            template_report: 'bh_sanko_vendor_evaluation.report_supplier_evaluation_form_single_action'
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`
            }
          }
        )
        .then((response) => {
          if (response.data.response_code === "0000") {
            const linkSource = `data:application/pdf;base64,${response.data.data.file}`;
            const downloadLink = document.createElement("a");
            const fileName = this.performance.name + ".pdf";
            downloadLink.href = linkSource;
            downloadLink.download = fileName;
            downloadLink.click();
          } else {
            if (response.data.response_code !== "4000"){
              this.$notify({
                type: 'warn',
                title: 'Warning',
                text: response.data.message,
              });
            }
          }
          this.loading = false
        })
        .catch((e) => {
          this.loading = false;
          this.$notify({
              type: 'error',
              title: 'Something went wrong!',
              text: e.response.data.message,
            });
        });
    }
  },
  mounted() {
    this.getDetail()
  }
};
</script>

<style>

</style>